import { JourneysLegacyRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/integrations/$')({
  component: JourneysLegacyRoute,
});
